import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/music_btn.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.activityData && _ctx.activityData.music && _ctx.activityData.music.isShow && _ctx.activityData.music.musicUrl)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["music", [!_ctx.isPlaying && 'paused']],
        onTouchstart: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchMusic && _ctx.switchMusic(...args)), ["stop"]))
      }, [
        _createVNode("audio", {
          ref: "audio",
          id: "audio",
          onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
          onPause: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args))),
          src: _ctx.activityData.music.musicUrl,
          loop: "",
          autoplay: ""
        }, null, 40, ["src"]),
        _hoisted_1
      ], 34))
    : _createCommentVNode("", true)
}